/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetProductsAsGroupName200ResponseDataInnerData } from './GetProductsAsGroupName200ResponseDataInnerData'
import {
  GetProductsAsGroupName200ResponseDataInnerDataFromJSON,
  GetProductsAsGroupName200ResponseDataInnerDataFromJSONTyped,
  GetProductsAsGroupName200ResponseDataInnerDataToJSON,
} from './GetProductsAsGroupName200ResponseDataInnerData'

/**
 *
 * @export
 * @interface Product
 */
export interface Product {
  /**
   *
   * @type {number}
   * @memberof Product
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof Product
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Product
   */
  title: string
  /**
   *
   * @type {number}
   * @memberof Product
   */
  price: number
  /**
   * Цена с примененой скидкой
   * @type {number}
   * @memberof Product
   */
  finalPrice?: number
  /**
   *
   * @type {GetProductsAsGroupName200ResponseDataInnerData}
   * @memberof Product
   */
  data?: GetProductsAsGroupName200ResponseDataInnerData
  /**
   *
   * @type {string}
   * @memberof Product
   */
  currenciesName: string
  /**
   *
   * @type {number}
   * @memberof Product
   */
  currenciesNumber: number
  /**
   *
   * @type {number}
   * @memberof Product
   */
  currenciesRatio: number
  /**
   *
   * @type {number}
   * @memberof Product
   */
  currenciesTitle: number
}

/**
 * Check if a given object implements the Product interface.
 */
export function instanceOfProduct(value: object): value is Product {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('title' in value) || value['title'] === undefined) return false
  if (!('price' in value) || value['price'] === undefined) return false
  if (!('currenciesName' in value) || value['currenciesName'] === undefined)
    return false
  if (!('currenciesNumber' in value) || value['currenciesNumber'] === undefined)
    return false
  if (!('currenciesRatio' in value) || value['currenciesRatio'] === undefined)
    return false
  if (!('currenciesTitle' in value) || value['currenciesTitle'] === undefined)
    return false
  return true
}

export function ProductFromJSON(json: any): Product {
  return ProductFromJSONTyped(json, false)
}

export function ProductFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Product {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    title: json['title'],
    price: json['price'],
    finalPrice: json['finalPrice'] == null ? undefined : json['finalPrice'],
    data:
      json['data'] == null
        ? undefined
        : GetProductsAsGroupName200ResponseDataInnerDataFromJSON(json['data']),
    currenciesName: json['currenciesName'],
    currenciesNumber: json['currenciesNumber'],
    currenciesRatio: json['currenciesRatio'],
    currenciesTitle: json['currenciesTitle'],
  }
}

export function ProductToJSON(value?: Product | null): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    name: value['name'],
    title: value['title'],
    price: value['price'],
    finalPrice: value['finalPrice'],
    data: GetProductsAsGroupName200ResponseDataInnerDataToJSON(value['data']),
    currenciesName: value['currenciesName'],
    currenciesNumber: value['currenciesNumber'],
    currenciesRatio: value['currenciesRatio'],
    currenciesTitle: value['currenciesTitle'],
  }
}
